import { RelativeTime } from './RelativeTime';
import { RefreshIcon } from './RefreshIcon';

// Token-class recipe for the account-toolbar "ghost" button with a two-line
// label (main + "Updated <relative>" meta). Mirrors TOOLBAR_BTN_BASE in
// RetailAccountCardToolbar so Refresh matches Force Rebalance / SignalForge in
// height and rhythm. Was `.account-toolbar-btn--ghost --with-meta` in
// accounts.css; both frontends render this without that stylesheet now.
const BTN =
  'box-border inline-flex cursor-pointer items-center gap-2 self-stretch rounded-[8px] border border-[rgba(255,255,255,0.12)] bg-[rgba(255,255,255,0.06)] py-2 pl-4 pr-3.5 text-left text-[12px] font-semibold leading-[1.2] text-[rgba(255,255,255,0.72)] transition-[background,border-color,color] duration-150 enabled:hover:bg-[rgba(255,255,255,0.1)] enabled:hover:text-[rgba(255,255,255,0.92)] disabled:cursor-not-allowed disabled:opacity-50 max-[640px]:pl-3.5 max-[640px]:pr-3';
const COPY = 'flex min-w-0 flex-col items-start gap-px';
const COPY_MAIN = 'whitespace-nowrap text-[12px] font-semibold leading-[1.2]';
const COPY_SUB =
  'whitespace-nowrap text-[10px] font-medium leading-[1.2] tracking-[0.02em] opacity-75 max-[640px]:hidden';

export type RefreshButtonWithMetaProps = {
  refreshing: boolean;
  onRefresh: () => void;
  lastUpdatedAt?: string | Date | null;
  label?: string;
  refreshingLabel?: string;
  title?: string;
};

export const RefreshButtonWithMeta = ({
  refreshing,
  onRefresh,
  lastUpdatedAt,
  label = 'Refresh',
  refreshingLabel = 'Refreshing…',
  title = 'Refresh portfolio data',
}: RefreshButtonWithMetaProps) => (
  <button
    type="button"
    className={BTN}
    onClick={onRefresh}
    disabled={refreshing}
    title={title}
    aria-label={refreshing ? refreshingLabel : title}
  >
    <RefreshIcon spinning={refreshing} />
    <span className={COPY}>
      <span className={COPY_MAIN}>{refreshing ? refreshingLabel : label}</span>
      {lastUpdatedAt && !refreshing && (
        <span className={COPY_SUB} aria-live="polite">
          Updated <RelativeTime value={lastUpdatedAt} />
        </span>
      )}
    </span>
  </button>
);
